<template>
  <Modal ref="modal">
    <div class="row">
      <div class="form-group col-6">
        <label class="col-4">Name:</label>
        <input
          class="form-control col"
          type="text"
          v-model="expense.name"
          placeholder="Name of expense"
        />
      </div>

      <div class="form-group col-4">
        <label class="col-4">Value:</label>
        <input
          class="form-control col"
          type="number"
          v-model="expense.value"
          placeholder="0.00"
          currency
        />
      </div>

      <div class="form-group col-2">
        <label class="col-4">Paid:</label>
        <!-- <input class="form-control" type="checkbox" v-model="expense.done" /> -->
        <MoneyCheckbox v-model="expense.done"></MoneyCheckbox>
      </div>
    </div>

    <div class="form-group">
      <label class="col-4">Description:</label>
      <textarea
        class="form-control col"
        v-model="expense.description"
      ></textarea>
    </div>

    <div v-if="expense.months">
      <MonthsCheckbox v-model="expense.months"></MonthsCheckbox>
    </div>

    <div class="form-group col-4" v-if="expense.months">
      <label class="col-4">Day:</label>
      <input
        class="form-control col"
        type="number"
        v-model="expense.day"
        min="1"
        max="31"
      />
    </div>

    <div class="form-group col-4" v-if="!expense.months">
      <label class="col-4">Date:</label>
      <input class="form-control col" type="date" v-model="date" :min="minDate | date" :max="maxDate | date"/>
    </div>

    <div class="form-group" v-if="canParentSelect">
      <label class="col-4">Parent:</label>
      <b-form-select
        v-model="expense.parent"
        :options="expenses"
      ></b-form-select>
    </div>

    <div>
      <button class="btn btn-dark" v-on:click="$refs.modal.ok()">OK</button>
      <button class="btn btn-dark" v-on:click="$refs.modal.cancel()">
        Anuluj
      </button>
    </div>
  </Modal>
</template>

<script>
import moment from 'moment';

export default {
  data() {
    return {
      expense: {},
      expenses: [],
      canParentSelect: false,
      minDate: undefined,
      maxDate: undefined
    };
  },
  computed: {
    date: {
      get() {
        return this.expense.date && moment(this.expense.date).format('YYYY-MM-DD');
      },
      set(value) {
        this.expense.date = value && moment(value).toDate();
      }
    }
  },
  methods: {
    show(expense, expenses, year, month) {
      this.expense = this.$tools.copyOf(expense);

      this.minDate = new Date(2020, 9, 1);
      this.maxDate = new Date(2020, 9, 31);

      if (expenses) {
        this.expenses = expenses
          .filter((item) => item !== expense && !item.parent)
          .map(({ id, name }) => ({
            value: id,
            text: name,
          }));

        this.expenses.splice(0, 0, {
          value: undefined,
          text: "",
        });
      }

      this.canParentSelect = expenses && !expenses.some((item) => item.parent === expense.id);

      return this.$refs.modal.open().then(() => {
        return this.expense;
      });
    },
  },
};
</script>

<style lang="scss" scoped>
</style>